import { z } from 'zod';

// Define the schema for contact request validation
export const contactSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  phone: z.string().min(1, 'Phone is required'),
  email: z.string().email('Invalid email').optional().or(z.literal('')),
  deliveryType: z.enum(['sea', 'air']),
  cityOfDeparture: z.string().min(1, 'City of departure is required'),
  deliveryCity: z.string().min(1, 'Delivery city is required'),
  // Honeypot: приховане поле, реальні користувачі його не заповнюють
  company: z.string().optional(),
});

// Type for the contact request body
export type ContactRequestBody = z.infer<typeof contactSchema>;

/**
 * Надсилає заявку на серверний endpoint (/api/contact).
 * Токен Telegram-бота живе тільки на сервері — клієнт його не бачить.
 */
export async function sendContactRequest(data: ContactRequestBody) {
  const response = await fetch('/api/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const result = await response.json().catch(() => null);

  if (!response.ok || !result || result.error) {
    throw new Error(
      (result && result.error) || 'Failed to send the request. Please try again later.'
    );
  }

  return { success: true as const };
}
